export default {
	idBoard: '5e320adb81f55f6a2180cbb5',
	idMember: '55317fc8a7a7e3e04a3d3f9c',
	// idBoard: 'MUCFgREx',
}
